"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHeatOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M24.85 15.37a6.25 6.25 0 01-1.67-5c.48-2.76 3.31-4.53 3.34-4.55L26 5l-.52-.86c-.15.09-3.63 2.24-4.27 5.91a8.13 8.13 0 002.08 6.58 6.1 6.1 0 011.64 4.92c-.49 2.79-3.41 4.57-3.44 4.59l1 1.72c.15-.09 3.72-2.25 4.39-5.95a8 8 0 00-2.03-6.54zM15.18 10.4c.48-2.76 3.31-4.53 3.34-4.55L18 5l-.52-.86c-.15.09-3.63 2.24-4.27 5.91a8.13 8.13 0 002.08 6.58 6.1 6.1 0 011.64 4.92c-.49 2.79-3.41 4.57-3.44 4.59l1 1.72c.15-.09 3.72-2.25 4.39-5.95a8 8 0 00-2-6.54 6.25 6.25 0 01-1.7-4.97zM7.18 10.4c.48-2.76 3.31-4.53 3.34-4.55L10 5l-.52-.86c-.15.09-3.63 2.24-4.27 5.91a8.13 8.13 0 002.08 6.58 6.1 6.1 0 011.64 4.92c-.49 2.79-3.41 4.57-3.44 4.59l1 1.72c.15-.09 3.72-2.25 4.39-5.95a8 8 0 00-2.05-6.54 6.25 6.25 0 01-1.65-4.97z" })));
}
exports.default = SvgHeatOutline;
//# sourceMappingURL=HeatOutline.js.map